import { api } from './api'

const enhancedApi = api.enhanceEndpoints({
  addTagTypes: [
    'partnerAppRequest',
  ],
})

const extendedApi = enhancedApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchPartnerAppRequests: builder.query({
      query: (params) => {
        return ({
          url: '/partner_app_requests',
          params: {
            page: params.page,
            ticketId: params.ticketId,
          },
        })
      },
    }),
  }),
  overrideExisting: false,
})

export const {
  useFetchPartnerAppRequestsQuery,
} = extendedApi
